module.exports = __webpack_public_path__ + "img/logo.291f7145.svg";